import { Angellist, Facebook, Github, LinkedinIn, Twitter } from '@styled-icons/fa-brands';

import { GetSocialMediaSiteLinks_WithShareLinks } from '../../../lib/social';
import { GlobeAmericas } from '@styled-icons/fa-solid/GlobeAmericas';
import { MailOutline } from '@styled-icons/material/MailOutline';
import styled from 'styled-components';
import { theme } from 'styled-tools';

const Icon = styled.i`
  display: inline-block;
  user-select: none;
  a {
    display: inline-block;
    color: ${theme('colors.white')};
    text-decoration: none;
    outline: none;
    transition: 0.3s;
    user-select: none;

    &:hover {
      opacity: 0.6;
    }
  }
`;

const SocialLink = ({ url = '', share = false, platform = '', shareParams = {}, ariaLabel, children }) => {
  let outUrl = url;
  if (share) {
    const params = Object.assign({}, shareParams, { url, via: 'foxboxhq' });

    const socialShares = GetSocialMediaSiteLinks_WithShareLinks(params);
    outUrl = socialShares[platform];
  }
  return (
    <a href={outUrl} target="_blank" rel="noopener noreferrer" aria-label={ariaLabel}>
      {children}
    </a>
  );
};

export const LinkedInLink = ({ url = '', size = 24, share = false, shareParams = {}, ...props }) => {
  return (
    <Icon>
      <SocialLink url={url} platform="linkedin" share={share} shareParams={shareParams} ariaLabel="LinkedIn">
        <LinkedinIn size={size} {...props} />
      </SocialLink>
    </Icon>
  );
};

export const TwitterLink = ({ url = '', size = 24, share = false, shareParams = {}, ...props }) => {
  return (
    <Icon>
      <SocialLink url={url} platform="twitter" share={share} shareParams={shareParams} ariaLabel="Twitter">
        <Twitter size={size} {...props} />
      </SocialLink>
    </Icon>
  );
};

export const AngelListLink = ({ url, size = 24, ...props }) => {
  return (
    <Icon>
      <SocialLink url={url} platform="angellist" share={false} ariaLabel="AngelList">
        <Angellist size={size} {...props} />
      </SocialLink>
    </Icon>
  );
};

export const FacebookLink = ({ url, size = 24, share = false, shareParams = {}, ...props }) => {
  return (
    <Icon>
      <SocialLink url={url} platform="facebook" share={share} shareParams={shareParams} ariaLabel="Facebook">
        <Facebook size={size} {...props} />
      </SocialLink>
    </Icon>
  );
};

export const GithubLink = ({ url, size = 24, ...props }) => {
  return (
    <Icon>
      <SocialLink url={url} platform="github" share={false} ariaLabel="GitHub">
        <Github size={size} {...props} />
      </SocialLink>
    </Icon>
  );
};

export const WebLink = ({ url, size = 24, ...props }) => {
  return (
    <Icon>
      <SocialLink url={url} platform="web" share={false} ariaLabel="Website">
        <GlobeAmericas size={size} {...props} />
      </SocialLink>
    </Icon>
  );
};

export const EmailLink = ({ url, size = 24, share, shareParams, ...props }) => {
  return (
    <Icon>
      <SocialLink url={url} platform="email" share={share} shareParams={shareParams} ariaLabel="Email">
        <MailOutline size={size} {...props} />
      </SocialLink>
    </Icon>
  );
};

export const getIcon = (socialNetworkName) => {
  switch (socialNetworkName) {
    case 'twitter':
      return TwitterLink;
    case 'facebook':
      return FacebookLink;
    case 'linkedIn':
      return LinkedInLink;
    case 'angelList':
      return AngelListLink;
    case 'github':
      return GithubLink;
    case 'web':
      return WebLink;
    default:
      return null;
  }
};
